import { logErr } from './logger';

/**
 * Converts the raw URL passed in to the canonical form we want to observe.
 * This allows us to ignore meaningless changes in the URL.
 * @param val - The raw URL
 * @return the canonical URL, or the empty string if val is not a valid URL
 */
export default function getUrlToObserve(val: string): string {
  try {
    const url = new URL(val);

    // Note: We need to handle hashes of the form #/abc... for SPAs
    // (They use these as a pseud-path to distinguish between different "pages")
    if (url.hash.includes('#/')) {
      return url.origin + url.pathname + url.hash;
    }

    return url.origin + url.pathname;
  } catch (e) {
    logErr(e);

    return '';
  }
}
